import { Model } from '../model';
import { Paginated } from '../paginated';

export class Contact extends Model {
  idContact: string;
}

export class Contacts extends Paginated {
  data: Array<Contact>;
}

export class ApiGetContactsOptionsFilter {
  'id-filter': string;
  type: string;
  condition: string;
  value: string;
}

export class ApiGetContactsOptions {
  'basic-filters': {
    name?: string;
    surname?: string;
    'id-group'?: string;
    email?: string;
    phone?: string;
  };
  filters: ApiGetContactsOptionsFilter[];
  'signed-for-sms': boolean;
  'signed-for-email': boolean;
  'signed-for-campaign': number;
}

export enum ContactEmailListStatus {
  NOT_SIGNED = 'NOT_SIGNED',
  CONFIRMED = 'CONFIRMED'
}
